import { Modal } from 'ant-design-vue';
import IconSuccess from '@/assets/image/screen/success.png';
import IconWarning from '@/assets/image/screen/warning.png';
import { createVNode } from 'vue';

export function ShowAlertModal({
  title = '提示',
  content = '是否停止录制？',
  okText = '确定',
  okLoading = false,
  type = 'warning',
}) {
  return new Promise((resolve, reject) => {
    Modal.info({
      title,
      content,
      okText,
      class: 'screen-record-confirm-modal',
      okButtonProps: {
        loading: okLoading,
      },
      icon: () =>
        createVNode('img', {
          className: 'anticon',
          src: type === 'warning' ? IconWarning : IconSuccess,
        }),
      onOk() {
        resolve(true);
      },
      onCancel() {
        reject(false);
      },
    });
  });
}

export function ShowConfirmModal({
  title = '提示',
  content = '是否停止录制？',
  okText = '确定',
  okLoading = false,
  cancelText = '取消',
  type = 'success',
}) {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title,
      content,
      okText,
      cancelText,
      class: 'screen-record-confirm-modal',
      okButtonProps: {
        loading: okLoading,
      },
      icon: () =>
        createVNode('img', {
          className: 'anticon',
          src: type === 'success' ? IconSuccess : IconWarning,
        }),
      onOk() {
        resolve(true);
      },
      onCancel() {
        reject(false);
      },
    });
  });
}
